/**
 * @name toothbrush-sparkles
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgM0g4IiAvPgogIDxwYXRoIGQ9Ik0xNC41ODYgMTEuNDE0IDIyIDQiIC8+CiAgPHBhdGggZD0iTTE1IDExYTggOCAwIDAxLS40MjkuNCIgLz4KICA8cGF0aCBkPSJtMiAyMiA3LTdjMS44NTctMS44NTcgMy43MTQtMS45OSA1LjU3MS0zLjZsLTEuOTg1LTEuOTg2QTIgMiAwIDAxMTQgNmEyIDIgMCAwMTItMiAyIDIgMCAwMTMuMjYyLTEuNTUybDIuMTUyIDIuMTM4IiAvPgogIDxwYXRoIGQ9Ik0yMCAxNXY0IiAvPgogIDxwYXRoIGQ9Ik0yMiAxN2gtNCIgLz4KICA8cGF0aCBkPSJNNCA1djQiIC8+CiAgPHBhdGggZD0iTTYgN0gyIiAvPgogIDxwYXRoIGQ9Ik05IDJ2MiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/toothbrush-sparkles
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const ToothbrushSparkles: string = `
<svg
  class="lucide lucide-toothbrush-sparkles"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M10 3H8" />
  <path d="M14.586 11.414 22 4" />
  <path d="M15 11a8 8 0 01-.429.4" />
  <path d="m2 22 7-7c1.857-1.857 3.714-1.99 5.571-3.6l-1.985-1.986A2 2 0 0114 6a2 2 0 012-2 2 2 0 013.262-1.552l2.152 2.138" />
  <path d="M20 15v4" />
  <path d="M22 17h-4" />
  <path d="M4 5v4" />
  <path d="M6 7H2" />
  <path d="M9 2v2" />
</svg>
`;

export default ToothbrushSparkles;
